import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing the van icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <VanCarIcon width={48} />
 */
const VanCarIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M20.17,12l0.07,0.45C20.7,12.81,21,13.37,21,14v4v3c0,0.55-0.45,1-1,1h-1c-0.55,0-1-0.45-1-1v-1H6v1
                  c0,0.55-0.45,1-1,1H4c-0.55,0-1-0.45-1-1v-3v-4c0-0.63,0.3-1.19,0.76-1.55L3.83,12H3.5C3.22,12,3,11.77,3,11.5v-2
                  C3,9.22,3.22,9,3.5,9h0.83l0.84-5.03C5.35,2.89,6.4,2,7.5,2h9c1.1,0,2.15,0.89,2.33,1.97L19.67,9h0.83C20.78,9,21,9.22,21,9.5v2
                  c0,0.27-0.22,0.5-0.5,0.5H20.17z M18.25,11.5l-0.59-3.51C17.57,7.44,17.05,7,16.5,7h-9C6.95,7,6.43,7.44,6.34,7.99L5.75,11.5H18.25z
                  M10,19h4c0.55,0,1-0.45,1-1H9C9,18.55,9.45,19,10,19z M5.25,13.5C4.56,13.5,4,14.06,4,14.75S4.56,16,5.25,16s1.25-0.56,1.25-1.25
                  S5.94,13.5,5.25,13.5z M18.75,13.5c-0.69,0-1.25,0.56-1.25,1.25S18.06,16,18.75,16S20,15.44,20,14.75S19.44,13.5,18.75,13.5z`}
        />
    </SvgIcon>
)

VanCarIcon.defaultProps = defaultProps

export { VanCarIcon }
